<template>
  <div class="dialog-wrap">
    <el-dialog title="物流信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="620px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               inline
               ref="dataForm"
               label-width="100px">
        <el-form-item label="快递信息："
                      prop="express_code">
          <el-select v-model="dataForm.express_code"
                     placeholder="请选择院快递公司"
                     :disabled="!editStatus"
                     style="width: 100%;">
            <el-option v-for="item in expressList"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=""
                      prop="express_no"
                      v-if="dataForm.express_code">
          <el-input v-model="dataForm.express_no"
                    placeholder="请输入快递单号"
                    :disabled="!editStatus"
                    style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button v-if="!editStatus"
                     @click="editStatus = true">编辑</el-button>
          <el-button v-if="editStatus"
                     type="primary"
                     @click="handleSubmit">保存</el-button>
        </el-form-item>
      </el-form>
      <div class="progress">
        <div class="label">快递进度：</div>
        <div class="value">
          <p class="tips"
             v-if="!expressInfo">暂无数据</p>
          <div class="info-list"
               v-else>
            <div class="info-item"
                 v-for="(item, index) of expressInfo.list"
                 :key="index">
              <div class="top">
                <span class="status">{{item.status}}</span>
                <span class="time">{{item.time}}</span>
              </div>
              <div class="content">
                <span>{{item.context}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { expressList } from '@/api/common'
import { warrantOrderExpress,warrantOrderShoping} from '@/api/warrant'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      editStatus: false,
      dataForm: {
        express_code: '',
        express_no: '',
      },
      expressList: [],
      expressInfo: null,
      rules: {
        /*   express_code: [{ required: true, message: '请选择快递公司', trigger: 'change' }], */
        express_no: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
        ],
        /*        express_no: [{
                 required: true,
                 validator: (rule, value, callback) => {
                   if (this.dataForm.express_code && this.dataForm.express_code == 'noexpress') {
                     callback()

                   } else {
                     callback(new Error('请输入快递单号'))
                   }
                 },
               }], */
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val

      if (val) {
        this.fetchExpressList()
      }
    },
    content(val) {
      if (val) {
        this.dataForm.express_code = val.express_code || ''
        this.dataForm.express_no = val.express_no || ''

        /*         if (!val.express_no) {
                  this.editStatus = true
                } else {
                  this.editStatus = false
                } */
        if (val.express_code && val.express_no) {
          this.fetchExpressInfo()
        }
      }
    },
  },
  methods: {
    // 快递列表查询
    fetchExpressList() {
      expressList({ pageSize: 20 }).then((res) => {
        if (res) {
          let list = res.list
          list.unshift({ code: '', name: '无需物流' })
          this.expressList = list
        }
      })
    },
    // 快递进度查询
    fetchExpressInfo() {
      warrantOrderExpress({ order_id: this.content.id }).then((res) => {
        if (res) {
          this.expressInfo = res
        }
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            id: this.content.id,
          })
          if (params.express_code == '') {
            params.express_code = ''
            params.express_no = ''
          }
          warrantOrderShoping(params)
            .then((res) => {
              this.$message.success(`更新成功`)

              this.editStatus = false
              this.$emit('submit')

              // 刷新物流信息
              this.fetchExpressInfo()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
      this.expressInfo = null
      this.dataForm = {
        express_code: '',
        express_no: '',
        express_name: '',
      }
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
  }

  .progress {
    display: flex;

    .label {
      width: 100px;
      text-align: right;
      padding-right: 12px;
    }
    .value {
      flex: 1;
    }

    .info-item {
      & + .info-item {
        margin-top: 10px;
      }
    }

    .status {
      font-size: 13px;
      font-weight: bold;
      margin-right: 5px;
    }
    .time {
      font-size: 12px;
    }
    .content {
      line-height: 1.5;
      font-size: 13px;
      color: #999999;
      margin-top: 5px;
    }
    .tips {
      font-size: 13px;
      color: #999999;
    }
  }
}
</style>
